import dayjs, { Dayjs } from "dayjs";
import { COUNTRIES } from "../constants/countries";
import { Player, PlayerWithCount } from "./shirts/types";
import { SocialNetworksData } from "../types/authTypes";
import settings from "../config/settings";

export default function FormatService() {
  const getCountryFlagUrlByName = (name: string | undefined) => {
    let flagUrl = "";

    if (name) {
      const country = COUNTRIES.find((c) => c.label === name);
      if (country) {
        flagUrl = `https://flagcdn.com/w40/${country.code.toLowerCase()}.png`;
      }
    }

    return flagUrl;
  };

  const purchaseCostFormat = (amount: string | undefined) => {
    let renderData = "";
    if (amount) {
      renderData = parseFloat(amount).toFixed(2) + " €";
    }
    return renderData;
  };

  const booleanFormat = (value: boolean) => {
    return value ? "Yes" : "No";
  };

  const showDateFormat = (date: string | Dayjs | undefined) => {
    let dataFormatted = "";

    if (date) {
      dataFormatted = dayjs(date).format("DD/MM/YYYY");
    }
    return dataFormatted;
  };

  const storeDateFormat = (date: string | Dayjs | undefined | null) => {
    let dataFormatted = "";

    if (date) {
      dataFormatted = dayjs(date).format("YYYY/MM/DD");
    }
    return dataFormatted;
  };

  const b64toBlob = (b64Data: string, contentType = "", sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  };

  const getPlayerName = (player: Player | PlayerWithCount) => {
    let formatted = player.name;

    if (player.alias && player.name !== player.alias) {
      formatted += ' "' + player.alias + '" ';
    }

    return formatted;
  };

  const getMoneyFormat = (value: number | undefined | null) => {
    let result = "";

    if (value !== null && value !== undefined && !isNaN(value)) {
      const currency = "€";
      result =
        currency +
        value.toLocaleString("nl-NL", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
    }

    return result;
  };

  const getUrlByName = (
    name: string,
    value: Array<SocialNetworksData>
  ): string => {
    const socialMediaObject = value.find((item) => item.name === name);
    return socialMediaObject?.url || "";
  };

  const capitalizeFirstLetter = (value: string) => {
    return value.charAt(0).toUpperCase() + value.slice(1);
  };

  const getUrlLogo = (url: string) => {
    return settings.public + url;
  };

  return {
    purchaseCostFormat,
    booleanFormat,
    showDateFormat,
    storeDateFormat,
    b64toBlob,
    getCountryFlagUrlByName,
    getPlayerName,
    getMoneyFormat,
    getUrlByName,
    capitalizeFirstLetter,
    getUrlLogo,
  };
}
